import React from 'react';
import { motion } from 'framer-motion';
import { AcademicCapIcon, ShieldCheckIcon } from '@heroicons/react/24/outline';

const Slide01Title: React.FC = () => {
  return (
    <div className="flex flex-col items-center justify-center h-full text-center px-8">
      <motion.div
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.6 }}
      >
        <span className="relative inline-block mb-6">
          <span
            className="absolute inset-0 text-7xl md:text-8xl font-black text-[#06b6d4] blur-xl opacity-50"
            aria-hidden="true"
          >
            Lumen8
          </span>
          <span className="relative text-7xl md:text-8xl font-black bg-gradient-to-r from-[#0ea5e9] to-[#06b6d4] bg-clip-text text-transparent">
            Lumen8
          </span>
        </span>
      </motion.div>
      <motion.h2
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, delay: 0.3 }}
        className="text-2xl md:text-3xl text-[#94a3b8] font-light mb-8"
      >
        AI-Powered Adaptive Learning for NSW Schools
      </motion.h2>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.6, delay: 0.6 }}
        className="flex items-center gap-4 text-[#64748b]"
      >
        <span className="flex items-center gap-2">
          <AcademicCapIcon className="w-5 h-5 text-[#10b981]" />
          Maths & English
        </span>
        <span className="text-[#334155]">•</span>
        <span className="flex items-center gap-2">
          <ShieldCheckIcon className="w-5 h-5 text-[#3b82f6]" />
          NSW Curriculum Aligned
        </span>
      </motion.div>
    </div>
  );
};

export default Slide01Title;
